module.exports = __webpack_public_path__ + "static/media/perez_diez_balanca_cuesta_morgan_schmidt.04eddbec.jpg";